import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import { fetchCategories, fetchSubCategoryByCategory } from '../../features/admin/placeSlice'
import { fetchServices } from '../../features/admin/serviceSlice'
import { FilterSection } from '../search/FiltersSidebar'

const OffersFilter = ({ openFilter, setOpenFilter, filters, setFilters, type }: { type: string, openFilter: boolean, setOpenFilter: any, filters: any, setFilters: (val: any) => void }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>()
    const { subCategories, categories } = useSelector((state: RootState) => state.placeSlice)
    const { services } = useSelector((state: RootState) => state.serviceSlice)
    useEffect(() => {
        dispatch(fetchCategories())
        dispatch(fetchServices())
        dispatch(fetchSubCategoryByCategory(1))
    }, [dispatch])


    useEffect(() => {
        if (filters.categoryId) {
            dispatch(fetchSubCategoryByCategory(filters.categoryId))
        }
    }, [dispatch, filters.categoryId])

    const resetFilters = () => {
        setFilters({
            categoryId: 1,
            subCategoryId: 0,
            rate: 0,
            services: [],
        });
    };

    const handleCategoryChange = (value: string) => {
        const id = Number(value);
        setFilters({
            ...filters,
            categoryId: id,
            subCategoryId: 0 // reset subcategory
        });
    };

    const handleSubCategoryChange = (value: string) => {
        setFilters({ ...filters, subCategoryId: Number(value) });
    };

    const handleFacilityChange = (value: string) => {
        const val = Number(value);
        const newServices = filters.services.includes(val)
            ? filters.services.filter((v: number) => v !== val)
            : [...filters.services, val];

        setFilters({ ...filters, services: newServices });
    };

    const handleRatingChange = (value: string) => {
        setFilters({ ...filters, rate: value });
    };

    return (
        <div className={`md:col-span-1 md:block p-6 md:h-full space-y-5 bg-white md:rounded-2xl shadow-md transition-all duration-300 ease-in-out ${openFilter ? 'xs:translate-x-0 xs:rounded-none xs:h-screen xs:overflow-y-auto xs:opacity-100 xs:fixed xs:z-[10001] xs:w-full xs:mt-0' : 'xs:-translate-x-full xs:opacity-0'} xs:top-0 xs:left-0 md:static md:opacity-100 md:translate-x-0 md:transform-none`}>
            {openFilter && (
                <button
                    onClick={() => setOpenFilter(false)}
                    className=" text-blue-500 text-xl md:hidden xs:block"
                >
                    ✕
                </button>
            )}

            {/* Category */}
            <FilterSection
                title={t("search-type")}
                options={categories
                    ?.filter((cat: any) => cat.id !== 2)
                    .map((cat: any) => ({
                        label: cat.title,
                        value: cat.id.toString(),
                    }))
                }
                selected={filters?.categoryId ? [filters.categoryId.toString()] : []}
                onChange={handleCategoryChange}
            />

            {/* SubCategory */}
            <FilterSection
                title={t("type")}
                options={subCategories?.map((sub: any) => ({
                    label: sub.title,
                    value: sub.id.toString(),
                }))}
                selected={filters?.subCategoryId ? [filters.subCategoryId.toString()] : []}
                onChange={handleSubCategoryChange}
            />

            {/* Rating */}
            <FilterSection
                title={t("rating")}
                options={[
                    { label: t('no-rate'), value: '0' },
                    { label: '1', value: '1' },
                    { label: '2', value: '2' },
                    { label: '3', value: '3' },
                    { label: '4', value: '4' },
                    { label: '5', value: '5' },
                ]}
                selected={filters.rate}
                onChange={handleRatingChange}
            />

            {/* Services */}
            <FilterSection
                title={t("services")}
                options={services?.map((ser: any) => ({
                    label: ser.title,
                    value: ser.id.toString(),
                }))}
                selected={filters.services.map(String)}
                onChange={handleFacilityChange}
                showMoreCount={5}
            />

            {/* Reset Button */}
            <button onClick={() => resetFilters()} className="w-full flex items-center justify-center gap-2 mt-6 px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:border-red-400 hover:text-red-600 hover:bg-red-50 transition-colors duration-200">
                {t("reset-filter")}
            </button>
        </div>
    )
}

export default OffersFilter
